<main class="pb-5 px-md-4 pt-3 container-fluid container-fluid-limited main-page">
        <div class="taskbook my-4">
            <div class="d-lg-flex justify-content-between align-items-center">
                <div>
                    <div>
                        <h1 class="fs-5">{{ 'taskbook.backlog' | translate }} </h1>
                        <p class="text-secondary welcome_desc">{{ 'backlog_desc' | translate }}</p>
                    </div>
                    @if((counters.inProgress + counters.toReview) > 0) {
                    <p class="py-1">
                        {{'taskbook.backlog.counter.1'|translate}} <strong>{{counters.inProgress + counters.toReview}} {{'taskbook.backlog.counter.2'|translate}}</strong> {{'taskbook.backlog.counter.3'|translate}} <br>
                        <strong>{{counters.toReview}}</strong> {{'taskbook.backlog.counter.4'|translate}} <strong>{{counters.inProgress}}</strong> {{'taskbook.backlog.counter.5'|translate}}
                    </p>
                    }
                </div>
                <div class="border-start pt-3 pb-2 ps-1 ps-lg-3 ms-lg-3">
                    <saved-filter [pageTitle]="pageTitle"
                                    [manageDate]="false"
                                    [managerInDialog]="true"
                                    [dateInterval]="dateInterval"
                                    [selectedNamedFilter]="selectedFilter"
                                    (filterChange)="onFilterChange($event)"
                                    [onlyWhereIAMAdmin]="true"></saved-filter>
                </div>
            </div>
            @if(!loading){
            <div>
                @if(tasks?.length > 0 && user){
                    <backlog-list [listItems]="tasks"
                                   [managers]="managers"
                                    [userId]="user.id"
                                    [selectedFilter]="selectedFilter"
                                    (onSelectTaskForDetails)="openTaskDetails($event)"
                                    (onArchived)="onArchived($event)"></backlog-list>
                }
                @else{
                    <div class="row pb-3" data-cy="emptyBacklog">
                        <div class="col-md-6 bg-white pb-5">
                            <div class="d-flex justify-content-center align-items-center pb-5">
                                <img src="/assets/images/add_comment/talking-people.svg" width="300" class="pt-md-5">
                            </div>
                        </div>
                        <div class="col-md-6 p-3">
                            <div class="text-secondary kudos-intro">
                                <h3 class="pt-3 pb-2">{{'backlog.empty_list_title' | translate}}</h3>
                                <p class="pb-2 fs-6">{{'backlog.empty_list_desc' | translate}}</p>
                                <ul class="fs-6">
                                    @if(teams?.length > 0){
                                        <li>
                                            {{'backlog.empty_list_desc1.1' | translate}} <a class="fw-bold" [routerLink]="['/timeline', teams[0].id]">{{'backlog.empty_list_desc1.2' | translate}}</a>
                                        </li>
                                    }
                                    <li>
                                        <a class="fw-bold" (click)="poll()" data-cy="createPollFromBacklog">
                                            {{'backlog.empty_list_desc3' | translate}}
                                        </a> {{'backlog.empty_list_desc3.1' | translate}}
                                    </li>
                                    <li>
                                        <a class="fw-bold" (click)="kudos()" data-cy="createKudosFromBacklog">
                                            {{'backlog.empty_list_desc4' | translate}}
                                        </a> {{'backlog.empty_list_desc4.1' | translate}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }
            </div>
            }
        </div>
</main>


